import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { getPartnerLeadById } from "../../../api/sales";
import { handleAxiosError } from "../../../config/action-config";
import ViewLeads from "./view.leads";
const emptySalesData = {
  company_name: "",
  email: "",
  linkedin_url: "",
  industry_value: "",
  project_name: "",
  priority: "",
  contact: "",
  stage_value: "",
  probability: "",
  address: "",
  project_description: "",
  estimated_budget: "",
  key_stakeholder: "",
  estimated_close_date: "",
};

export default function ViewCustomLeads() {
  const user = useSelector((state) => state.user);
  const [data, setData] = useState(null);
  const params = useParams();
  const dispatch = useDispatch();

  useEffect(() => {
    if (!params.id) {
    } else {
      loadMasterData();
    }
  }, [params.id]);
  async function loadMasterData() {
    try {
      const { data } = await getPartnerLeadById(params.id, user.token);
      setData(data.leaddetails);
    } catch (error) {
      handleAxiosError(error, dispatch);
    }
  }
  return data ? (
    <ViewLeads preloadedValues={data} refresh={loadMasterData} />
  ) : (
    <div className="center">Loading.....</div>
  );
}
